var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"error",staticClass:"home-modal-toast"},[_c('img',{attrs:{"src":require("@/assets/error.svg"),"alt":""}}),_c('h2',[_vm._v(_vm._s(_vm.$t("homeModalToastError.titleError")))]),_c('span',[_vm._v(" "+_vm._s(_vm.errorMsg)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }